import { __assign, __generator } from "tslib";
import { eventChannel, buffers } from 'redux-saga';
import { select, call, takeEvery, all, fork, take } from 'redux-saga/effects';
import isSSR from '../../utils/isSSR';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { PureBiData, } from '@wix/da-bi/pkg/events';
import { logPageView } from './actions';
import { getPublicSession } from '../../publicSession/selectors';
import { getBiContextData } from './selectors';
import isFinite from 'lodash/isFinite';
import isNumber from 'lodash/isNumber';
// helper for logging events from sagas
export function logBiEvent(data, isPageView) {
    var contextData;
    if (isPageView === void 0) { isPageView = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(isPageView ? getPublicSession : getBiContextData)];
            case 1:
                contextData = _a.sent();
                return [4 /*yield*/, call([biLogger, 'log'], contextData, data)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleLogPageView(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (isSSR()) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(logBiEvent, PureBiData(__assign({ evid: 99, screen_width: window.innerWidth, screen_height: window.innerHeight }, payload)), true)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function makeBiData(beat, metrics) {
    var _a;
    var data = {
        evid: 1,
        // project
        appinf: (_a = window['__APP_INFO__']) !== null && _a !== void 0 ? _a : 'unknown',
        beat: beat,
    };
    var metricMap = {
        FP: 'p_fp',
        FCP: 'p_fcp',
        FID: 'p_fid',
        LCP: 'p_lcp',
        CLS: 'p_cls',
        TTFB: 'nt_ttfb',
        fetchTime: 'nt_ft',
        workerTime: 'nt_wt',
        totalTime: 'nt_tt',
        downloadTime: 'nt_dt',
        headerSize: 'nt_hs',
        dnsLookupTime: 'nt_dlt',
        downlink: 'ni_dl',
        effectiveType: 'ni_et',
        rtt: 'ni_rtt',
        saveData: 'ni_sd',
    };
    for (var _i = 0, metrics_1 = metrics; _i < metrics_1.length; _i++) {
        var metric = metrics_1[_i];
        // Record the vital bracket poor, needs improvement, good
        if (metric.vitalsScore) {
            data["".concat(metric.type, "_vs").toLocaleLowerCase()] = metric.vitalsScore;
        }
        // Record things with a duration only
        if (metric.duration && metricMap[metric.type]) {
            data[metricMap[metric.type]] = Math.round(metric.duration);
            continue;
        }
        // Walk the data object and extract stuff
        if (metric.data) {
            var keys = Object.keys(metric.data);
            if (keys.length > 0)
                for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
                    var key = keys_1[_b];
                    if (!metricMap[key]) {
                        continue; // skip missing
                    }
                    if (isFinite(metric.data[key])) {
                        data[metricMap[key]] = Math.round(metric.data[key]);
                    }
                    else {
                        data[metricMap[key]] = metric.data[key];
                    }
                }
        }
    }
    return PureBiData(data);
}
function handlePerfLogging() {
    var Perfume, e_1, perfumeChannel, metrics, fcpDone, ttfbDone, log, metricName, data, vitalsScore, duration, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (typeof window === 'undefined') {
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, import('perfume.js')];
            case 2:
                Perfume = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                e_1 = _b.sent();
                return [2 /*return*/];
            case 4:
                perfumeChannel = eventChannel(function (emitter) {
                    new Perfume.default({
                        logging: false,
                        dataConsumption: false,
                        networkInformation: true,
                        resourceTiming: false,
                        analyticsTracker: function (log) { return emitter(log); },
                    });
                    return function () { };
                }, buffers.expanding());
                metrics = [];
                fcpDone = false, ttfbDone = false;
                _b.label = 5;
            case 5:
                if (!true) return [3 /*break*/, 19];
                return [4 /*yield*/, take(perfumeChannel)];
            case 6:
                log = _b.sent();
                metricName = log.metricName, data = log.data, vitalsScore = log.rating;
                duration = void 0;
                if (isNumber(data)) {
                    duration = data;
                }
                _a = metricName;
                switch (_a) {
                    case 'navigationTiming': return [3 /*break*/, 7];
                    case 'networkInformation': return [3 /*break*/, 8];
                    case 'FCP': return [3 /*break*/, 9];
                    case 'TTFB': return [3 /*break*/, 12];
                }
                return [3 /*break*/, 15];
            case 7:
                metrics.push({
                    type: metricName,
                    data: data,
                    vitalsScore: vitalsScore,
                });
                return [3 /*break*/, 18];
            case 8:
                metrics.push({
                    type: metricName,
                    data: data,
                });
                return [3 /*break*/, 18];
            case 9:
                fcpDone = true;
                metrics.push({
                    type: metricName,
                    duration: duration,
                    vitalsScore: vitalsScore,
                });
                if (!ttfbDone) return [3 /*break*/, 11];
                return [4 /*yield*/, call(logBiEvent, makeBiData('fcp', metrics))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [3 /*break*/, 18];
            case 12:
                ttfbDone = true;
                metrics.push({
                    type: metricName,
                    duration: duration,
                    vitalsScore: vitalsScore,
                });
                if (!fcpDone) return [3 /*break*/, 14];
                return [4 /*yield*/, call(logBiEvent, makeBiData('fcp', metrics))];
            case 13:
                _b.sent();
                _b.label = 14;
            case 14: return [3 /*break*/, 18];
            case 15:
                metrics.push({
                    type: metricName,
                    duration: duration,
                    vitalsScore: vitalsScore,
                });
                if (!(metricName === 'LCP')) return [3 /*break*/, 17];
                return [4 /*yield*/, call(logBiEvent, makeBiData('lcp', metrics))];
            case 16:
                _b.sent();
                metrics = [];
                _b.label = 17;
            case 17: return [3 /*break*/, 18];
            case 18: return [3 /*break*/, 5];
            case 19: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fork(handlePerfLogging)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([takeEvery(logPageView, handleLogPageView)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map